import type { DiagnosticModule } from '../types/content';

export const modules: DiagnosticModule[] = [
  {
    number: 1,
    title: 'Diesel Diagnostic Foundations & Troubleshooting Workflow',
    short: 'Workflow',
    accent: '#5B6E80',
    description:
      'Follow a structured diesel diagnostic process from initial symptom to root cause. Use preliminary inspections, DTC analysis, live data, testing sequences and decision points to determine what to check next.',
    tagline: 'Start. Test. Decide.',
  },
  {
    number: 2,
    title: 'Fuel System & Common Rail Diagnostics',
    short: 'Fuel',
    accent: '#D7263D',
    description:
      'Troubleshoot fuel supply, low pressure, rail pressure, air ingress, pump and injector-related problems. Work through structured paths for hard starting, rough running and loss of power.',
    tagline: 'Measure. Compare. Diagnose.',
  },
  {
    number: 3,
    title: 'Air Intake, Turbo & Boost Diagnostics',
    short: 'Turbo',
    accent: '#F26B1D',
    description:
      'Find airflow, turbocharger and boost faults with structured diagnostic tests. Work through intake restrictions, boost leaks, boost pressure, MAP and MAF sensors, actuators and turbo control.',
    tagline: 'Inspect. Test. Verify.',
  },
  {
    number: 4,
    title: 'Electrical, Sensor & Actuator Diagnostics',
    short: 'Electrical',
    accent: '#1F6FD1',
    description:
      'Turn electrical symptoms, sensor data and actuator codes into clear diagnostic decisions. Use supply and ground checks, circuit testing, voltage-drop checks, signal analysis and actuator verification.',
    tagline: 'Scan. Trace. Test.',
  },
  {
    number: 5,
    title: 'EGR, DPF, SCR & Emissions Diagnostics',
    short: 'Emissions',
    accent: '#1E9E4A',
    description:
      'Troubleshoot modern diesel emissions and aftertreatment problems. Work through EGR, DPF and regeneration, pressure and temperature sensors, SCR and AdBlue/DEF diagnostic paths.',
    tagline: 'Check. Compare. Diagnose.',
  },
  {
    number: 6,
    title: 'Advanced Diesel Fault Diagnosis & Real-World Cases',
    short: 'Cases',
    accent: '#7B3FC4',
    description:
      'Study cases organized by symptom, evidence, tests, decisions, identified cause and final verification — including intermittent faults and problems that appear after previous repairs or service work.',
    tagline: 'Identify. Isolate. Confirm.',
  },
];
